import * as R from "ramda";
import React, {Component, Fragment} from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import ReceivingUnitNOSDetail from "./receivingUnitNOSDetail";
import ReceivingUnitNOSFilter from "./receivingUnitNOSFilter";
import ReceivingUnitNOSProcess from "./receivingUnitNOSProcess";
import {formGroupNOSCreate, tableColumns} from "../config";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import Api from "../../../../../Services/Api";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import M from "moment";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import {contructQueryParam, fetchDataAsync, getUserAccess} from "../../../../../Services/Utils";
import SimplePrintTable from "../../../../../modules/popup/SimplePrintTable";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {HttpStatus} from "../../../../common/Constants";
import { saveAs } from "file-saver";

class ReceivingUnitNOS extends Component {
    constructor(props) {
        super(props);
        this.initialFilterData = {
            spbmNo: null,
            startDateSPBM: null,
            endDateSPBM: null,
            slNo: null,
            startDateSL: null,
            endDateSL: null,
            manual: null,
            variantCode: null,
            machineCode: null,
            frameCode: null,
            colorCode: null,
            rfsStatus: null,
            yearManufactured: null,
            locatorCode: null,
        };
        this.initialSearch = {
            startDateSPBM: null,
            endDateSPBM: null,
        }
        this.state = {
            isEditable: false,
            filterModalVisible: false,
            detailModalVisible: false,
            processModalVisible: false,
            alertModalVisible: false,
            printModalVisible: false,
            alertText: null,
            userAccess: null,
            selectedData: null,
            dataTable: [],
            dataCabang: [],
            dataDetail: null,
            selectedCabang: null,
            filterData: this.initialFilterData,
            search: this.initialSearch,
            pagination: {
                count: 10,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            },
            tableColumns: tableColumns(this.handleModalDetailVisibility),
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        this.setState((prevState) => ({
            ...prevState,
            search: {
                startDateSPBM: M(new Date()).format("DD-MM-YYYY"),
                endDateSPBM: M(new Date()).format("DD-MM-YYYY"),
            }
        }));
        await this.fetchDataCabang();
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (!R.equals(this.state.search.dealerCode, prevState.search.dealerCode)) {
            this.setState((prevState) => ({
              ...prevState,
              filterData: this.initialFilterData,
              search: {
                ...prevState.search,
                startDateSPBM: M(new Date()).format("DD-MM-YYYY"),
                endDateSPBM: M(new Date()).format("DD-MM-YYYY"),
              },
              pagination: {
                count: 0,
                limit: 5,
                page: 1,
              },
            }),async ()=>{
                this.handleTriggerLoading();
                await this.fetchData({
                    ...removeNullFields(this.parseFilterData(this.state.search)),
                    limit: this.state.pagination.limit,
                    page: 1
                });
                const userAccess = getUserAccess(this.props.menuAccess, this.state.search.dealerCode.value);

                this.setState((prevState) => ({
                    ...prevState,
                    userAccess: userAccess,
                    tableColumns: tableColumns(this.handleModalDetailVisibility, userAccess)
                }))

                this.handleTriggerLoading();
            });
        }
    }

    handleModalFilterVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            selectedCabang: this.state.search.dealerCode,
            filterModalVisible: !prevState.filterModalVisible,
        }));
    };

    handleModalDetailVisibility = (index, isEditable) => {
        this.setState((prevState) => ({
            ...prevState,
            selectedData: prevState.dataTable[index],
            selectedCabang: this.state.search.dealerCode,
            detailModalVisible: !prevState.detailModalVisible,
            isEditable: !!isEditable
        }))
    };

    handleProcessModalVisibility = (isEditable) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedCabang: this.state.search.dealerCode,
            processModalVisible: !prevValue.processModalVisible,
            isEditable: isEditable
        }));
    };

    handleAlertModalVisibility = (text) => {
        this.setState((prevState) => ({
            ...prevState,
            alertText: text ? text : null,
            alertModalVisible: !prevState.alertModalVisible,
        }))
    }

    handleInputDateChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: M(value).format("DD-MM-YYYY"),
            },
        }));
    };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleFilterValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleOnSubmitSearch = async () => {
        this.handleTriggerLoading()
        // this.handleRefreshPagination()
        await this.fetchData({
            ...removeNullFields(this.parseFilterData(this.state.search)),
            limit: this.state.pagination.limit,
            page: 1
        });
        this.handleClearFormFilter();
        this.handleTriggerLoading()
    }

    handleOnSubmitFilter = async () => {
        this.handleTriggerLoading()
        // this.handleRefreshPagination()
        await this.fetchData({
            ...removeNullFields(this.parseFilterData(this.state.filterData)),
            dealerCode: this.state.search.dealerCode.value,
            limit: this.state.pagination.limit,
            page: 1
        });
        this.handleClearSearch();
        this.handleModalFilterVisibility();
        this.handleTriggerLoading()
    }

    handleOnSubmit = async (action, data, list) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(data);
        
        const requestBody = {
            ...formGroup,
            spbmNo: R.equals(action, "save") ? null : formGroup.spbmNo,
            jumlah: list.length,
            details: list,
            kodeSupplier: getValueFromDDL(formGroup, "kodeSupplier"),
            kodeSupplierExpedition: getValueFromDDL(formGroup, "kodeSupplierExpedition"),
            kodeCabang: getValueFromDDL(formGroup, "kodeCabang"),
        };

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE").submitReceivingUnitNOS,
            menuName: "Receiving Unit - NOS",
            setError: this.props.setError,
            args: requestBody,
        });
        if (res.ok) {
            // this.setState((prevState) => ({
            //   ...prevState,
            //   search: {
            //     ...prevState.search,
            //     startDateSPBM: M(new Date()).format("DD-MM-YYYY"),
            //     endDateSPBM: M(new Date()).format("DD-MM-YYYY"),
            //   },
            // }));
            // this.handleRefreshPagination()
            // await this.fetchData({
            //     ...removeNullFields(this.parseFilterData(this.state.search)),
            //     limit: this.state.pagination.limit,
            //     page: 1
            // });
            await this.handleRefetchAfterProcess()

            if (R.equals(action, "save")) {
                this.handleProcessModalVisibility();
            } else {
                this.handleModalDetailVisibility();
            }

            this.handleAlertModalVisibility("Data Telah Disimpan.");
        }
        this.handleTriggerLoading();
    }

    handleOnDelete = async () => {
        try {
            this.handleTriggerLoading();
            await Api.create("NAGAMAS_TRANSACTION").deleteReceivingUnitNOS(contructQueryParam({
                spbmNo: this.state.selectedData.spbmNo
            }));
            // this.handleRefreshPagination()
            this.handleAlertModalVisibility("Data Telah Dihapus.");
            this.handleModalDetailVisibility();
            // await this.fetchData({
            //     ...removeNullFields(this.parseFilterData(this.state.search)),
            //     limit: this.state.pagination.limit,
            //     page: 1
            // });
            await this.handleRefetchAfterProcess()
            this.handleTriggerLoading();
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handlePrint = async () => {
        this.handleTriggerLoading()
        try {
            const res = await Api.create("NAGAMAS_TRANSACTION_FILE").downloadReceivingUnitNOSExcel({
              dealerCode: this.state.search.dealerCode?.value,
            });
            console.log(res)
            if(res.ok){
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                saveAs(blob, 'RECEIVING_UNIT_NOS.xlsx')
            }
        } catch (error) {
            console.log(error)
        }
        this.handleTriggerLoading()
    }

    handleClearFormFilter = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: {
                ...prevState.filterData,
                ...this.initialFilterData
            },
        }));
    }

    handleClearSearch = () => {
        this.setState((prevState) => ({
            ...prevState,
            search: {
                ...prevState.search,
                ...this.initialSearch
            },
        }));
    }

    handleChangePage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));

        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest, dealerCode: this.state.search.dealerCode.value};
        } else {
            paramFilters = {...searchRequest};
        }

        await this.fetchData({
            ...paramFilters,
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                count: 1,
                page: 1,
                limit: limit,
            }
        }));

        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest, dealerCode: this.state.search.dealerCode.value};
        } else {
            paramFilters = {...searchRequest};
        }

        await this.fetchData({
            ...paramFilters,
            page: 1,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_TRANSACTION").getAllReceivingUnitNOSByParam(
                body && Object.keys(body).length > 0 ?
                    body :
                    {page: 1, limit: 5}
            );

            if (res.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: res.data.data.map(data => {
                        return {
                            ...data,
                            manual: data.manual ? "Yes" : "No",
                        }
                    }),
                    pagination: {
                        ...prevValue.pagination,
                        count: res.data.totalData ? res.data.totalData : 5,
                    }
                }));
            }
        } catch (e) {
            console.log("errors: ", e);
        }
    }

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        search: {
                            ...prevValue.search,
                            dealerCode: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                        }
                    }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    parseFilterData(data) {
        const rfsStatus = getValueFromDDL(data, "rfsStatus");
        const parsedRfsStatus = R.isNil(rfsStatus) ? null
            : rfsStatus === true ? "RFS" : rfsStatus === false ? "NRFS" : null;
        const yearManufactured = !R.isNil(data.yearManufactured) ? Number(data.yearManufactured) : null;

        return {
            ...data,
            dealerCode: getValueFromDDL(data, "dealerCode"),
            variantCode: getValueFromDDL(data, "variantCode"),
            colorCode: getValueFromDDL(data, "colorCode"),
            locatorCode: getValueFromDDL(data, "locatorCode"),
            manual: getValueFromDDL(data, "manual"),
            rfsStatus: parsedRfsStatus,
            yearManufactured: yearManufactured
        };
    }

    handleRefreshPagination=()=>{
      this.setState((prevState) => ({
        ...prevState,
        pagination: {
          count: 0,
          limit: 5,
          page: 1,
        },
      }));
    }

    handleRefetchAfterProcess = async () => {
        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest, dealerCode: this.state.search.dealerCode.value};
        } else {
            paramFilters = {...searchRequest};
        }

        await this.fetchData({
            ...paramFilters,
            page: this.state.pagination.page,
            limit: this.state.pagination.limit
        });
    }

    render() {
        return (
            <>
                <FlexView
                    style={{justifyContent: "space-between"}}
                    vAlignContent="center"
                    className="margin-top-5px"
                >
                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                        <SimpleDDL
                            id="select_options_nama_cabang"
                            box="search"
                            name="dealerCode"
                            containerclassname="width width-250px"
                            placeholder="Nama Cabang"
                            menuPosition="fixed"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.search.dealerCode}
                            onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                        />
                        <SimpleDate
                            id="select_date_from"
                            nextdate
                            date={this.state.search.startDateSPBM}
                            maxDate={this.state.search.endDateSPBM}
                            onChange={(value) => this.handleInputDateChange("startDateSPBM", value)}
                        />
                        <SimpleDate
                            id="select_date_to"
                            date={this.state.search.endDateSPBM}
                            onChange={(value) => this.handleInputDateChange("endDateSPBM", value)}
                        />
                        <SimpleButton onClick={this.handleOnSubmitSearch}
                                      className="margin-bottom-20px">Cari</SimpleButton>
                    </FlexView>
                    <SimpleButton
                        className={"btn background-red margin-bottom-20px"}
                        styles={{width: "unset"}}
                        onClick={this.handleModalFilterVisibility}
                        icon={<i className="fa fa-qrcode"></i>}
                    />
                </FlexView>

                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableColumns}
                    toCount={this.state.pagination.count}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(
                        (tableState) => this.handleChangePage(tableState),
                        (tableState) => this.handleChangeRowsPerPage(tableState),
                    )}
                    footerAdditionalButtons={
                        <Fragment>
                            {this.state.userAccess && this.state.userAccess.createAccess && (
                                <SimpleButton
                                    onClick={() => this.handleProcessModalVisibility(true)}
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    text={"Tambah Data"}
                                />
                            )}

                            <SimpleButton
                                onClick={() => this.handlePrint()}
                                icon={<i className="fa fa-lw fa-print margin-right-10px"></i>}
                                text={"Print"}
                            />
                        </Fragment>
                    }
                />

                {this.state.filterModalVisible && (
                    <ReceivingUnitNOSFilter
                        setError={this.props.setError}
                        selectedData={this.state.filterData}
                        selectedCabang={this.state.selectedCabang}
                        visible={this.state.filterModalVisible}
                        onValueChange={this.handleFilterValueChange}
                        onSubmit={this.handleOnSubmitFilter}
                        onClearForm={this.handleClearFormFilter}
                        onClickClose={this.handleModalFilterVisibility}
                    />
                )}

                {this.state.detailModalVisible && (
                    <ReceivingUnitNOSDetail
                        isEditable={this.state.isEditable}
                        setError={this.props.setError}
                        formGroup={formGroupNOSCreate}
                        initialValues={this.state.selectedData}
                        selectedCabang={this.state.selectedCabang}
                        userAccess={this.state.userAccess}
                        visible={this.state.detailModalVisible}
                        onSubmit={this.handleOnSubmit}
                        onDelete={this.handleOnDelete}
                        onClickClose={this.handleModalDetailVisibility}
                    />
                )}

                {this.state.processModalVisible && (
                    <ReceivingUnitNOSProcess
                        isEditable={this.state.isEditable}
                        setError={this.props.setError}
                        formGroup={formGroupNOSCreate}
                        initialValues={this.state.selectedData}
                        selectedCabang={this.state.selectedCabang}
                        visible={this.state.processModalVisible}
                        onSubmit={this.handleOnSubmit}
                        onClickClose={this.handleProcessModalVisibility}
                    />
                )}

                {this.state.alertModalVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={this.state.alertText}
                        visible={this.state.alertModalVisible}
                        onClickClose={this.handleAlertModalVisibility}
                        additionalButtons={
                            <SimpleButton
                                type="button"
                                text="OK"
                                onClick={() => this.handleAlertModalVisibility()}
                            />
                        }
                    />
                )}

                {this.state.printModalVisible && <SimplePrintTable onClearPrint={this.handlePrint}/>}
                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(ReceivingUnitNOS);